import { Controller } from "@hotwired/stimulus"

// 알림 다이얼로그 컨트롤러 - Design System v3
// 알림 열기/닫기, ESC 키 처리, 포커스 관리 제공
export default class extends Controller {
  static targets = ["container", "content", "body", "footer"]
  static values = { autoOpen: { type: Boolean, default: false } }

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    this.handleFocusTrap = this.handleFocusTrap.bind(this)

    // 커스텀 이벤트로 alert 열기 지원 — 다른 컨트롤러에서 dispatch 가능.
    this.element.addEventListener('alert:open', () => this.open())

    // auto_open 이 true 이면 렌더링 즉시 열기.
    // 한 번 연 뒤 false 로 토글 — bfcache/turbo-cache 에서 페이지 복원 시
    // 재 connect 되어도 다시 열리지 않게 함.
    if (this.autoOpenValue) {
      this.autoOpenValue = false
      this.open()
    }
  }

  disconnect() {
    this.removeEventListeners()
    this.restoreBodyScroll()
  }

  open(event) {
    if (event) event.preventDefault()

    this.containerTarget.classList.remove("hidden")
    this.preventBodyScroll()
    this.addEventListeners()
    this.focusFirstElement()
  }

  close(event) {
    if (event) event.preventDefault()

    this.containerTarget.classList.add("hidden")
    this.restoreBodyScroll()
    this.removeEventListeners()

    // Dispatch custom event for close
    this.dispatch("close", { detail: { alert: this } })
  }

  // Private methods

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.stopPropagation()
      this.close(event)
    }
  }

  handleFocusTrap(event) {
    if (event.key !== "Tab") return

    const focusableElements = this.contentTarget.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        event.preventDefault()
        lastElement?.focus()
      }
    } else {
      if (document.activeElement === lastElement) {
        event.preventDefault()
        firstElement?.focus()
      }
    }
  }

  focusFirstElement() {
    const focusableElements = this.contentTarget.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
    const firstElement = focusableElements[0]
    firstElement?.focus()
  }

  addEventListeners() {
    document.addEventListener("keydown", this.handleKeydown)
    document.addEventListener("keydown", this.handleFocusTrap)
  }

  removeEventListeners() {
    document.removeEventListener("keydown", this.handleKeydown)
    document.removeEventListener("keydown", this.handleFocusTrap)
  }

  preventBodyScroll() {
    this.originalOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
  }

  restoreBodyScroll() {
    document.body.style.overflow = this.originalOverflow || ""
  }
}
